/**
 * Sichtbarkeits-Helper fuer den Marktplatz (Unternehmensgruppen-Feature).
 *
 * Listings koennen 'public' (alle Mandanten) oder 'group' (nur Mandanten
 * derselben Unternehmensgruppe / Konzern-Hierarchie im SSO) sein. Das
 * Backend liefert im Browse-Endpoint bereits nur die fuer den Mandanten
 * sichtbaren Listings — diese Helper steuern rein die UI-Darstellung
 * (Gruppen-Filter, Chips, Button-Beschriftung bei 0-€-Angeboten).
 */

export type ListingScope = 'all' | 'group';

export interface VisibilityAware {
    visibility?: string;
}

export const isGroupListing = (listing: VisibilityAware): boolean =>
    listing.visibility === 'group';

export const hasGroupListings = (listings: VisibilityAware[]): boolean =>
    listings.some(isGroupListing);

export const filterListingsByScope = <T extends VisibilityAware>(
    listings: T[],
    scope: ListingScope,
): T[] => (scope === 'group' ? listings.filter(isGroupListing) : listings);

/**
 * 0-€-Angebote (typisch: Konzern verteilt Inhalte kostenlos an die
 * Tochterhaeuser) sollen nicht wie ein Kauf wirken.
 */
export const purchaseButtonLabel = (
    price: string | null | undefined,
    purchasing: boolean,
): string => {
    if (purchasing) return 'Wird verarbeitet...';
    if (!price || parseFloat(price) === 0) return 'Kostenlos beziehen';
    return 'Jetzt lizenzieren';
};

/**
 * Anbieten und Kaufen liegen im Backend auf verschiedenen Rollen: eigene
 * Angebote darf der Content-Manager pflegen (`/api/marketplace/listings`),
 * Lizenzieren, Lizenzen und Verkaeufe verlangen ROLE_COMPANY_ADMIN.
 */
export const canLicenseCourses = (roles: string[]): boolean =>
    roles.some((role) =>
        ['ROLE_COMPANY_ADMIN', 'ROLE_OPERATOR', 'ROLE_PLATFORM_ADMIN'].includes(role),
    );
